import { CommonOptions, getNewLine } from "../common"

export const format = (out: any, newLine?: string) => {
  const nl = getNewLine(newLine)

  // this is a workaround for Endnote
  // which requires us to have the following if PMID is present:
  //
  // XX  - <empty line>
  // PMID  - <value>
  // ER  -

  const pmidIndex =
    out
      .findIndex((entry: any) => entry[0] === "PMID")

  if (pmidIndex > -1) {
    const pmidEntry = out.splice(pmidIndex, 1)[0]
    out.splice(out.length - 1, 0, ["XX", ""], pmidEntry)
  }

  const frmt = out
    .map((entry: any) => {
      const [ key, value ] = entry
      return `${key}  - ${value}`
    })
    .join(nl)

  return frmt + nl
}
